import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  tracability: null,
};

const slice = createSlice({
  name: "tracability",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET REPORTS
    getTracabilityCompagnySuccess(state, action) {
      state.isLoading = false;
      state.tracability = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getTracabilityCompagny(
  filterStartDate,
  filterEndDate,
  tip,
  page=1,
  page_size=64
) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/dashboard/tracabilites-${tip}?start_date=${filterStartDate}&end_date=${filterEndDate}&page_size=${page_size}`
      );
      dispatch(slice.actions.getTracabilityCompagnySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
